import { useRouter, useShowToast } from '@application/utils';
import { useCallback, useEffect } from 'react';

interface UseRedirectParams {
  currentAccountType: 'breeder' | 'buyer';
  breederUrl?: string | null;
}
export const useRedirect = (params: UseRedirectParams) => {
  const { currentAccountType, breederUrl } = params;
  const { navigateToRoute, goBack, translate } = useRouter();
  const { showToast } = useShowToast();
  const showErrorToast = useCallback(() => {
    showToast(translate('common.toasts.application.no-breeder-allowed'), {
      type: 'error',
      toastId: 'no-breeder-allowed',
    });
  }, [showToast, translate]);

  useEffect(() => {
    if (currentAccountType === 'breeder') {
      showErrorToast();
      if (breederUrl) {
        navigateToRoute('breeder', { params: [breederUrl] });
      } else {
        goBack();
      }
    }
  }, [breederUrl, currentAccountType, goBack, navigateToRoute, showErrorToast]);
};
